import { Box } from '@mantine/core';

const SWATCH_SIZE = 12;
const SWATCH_RADIUS = 3;

interface LegendSwatchProps {
  color: string;
  opacity?: number;
}

export const LegendSwatch = ({ color, opacity }: LegendSwatchProps) => (
  <Box
    w={SWATCH_SIZE}
    h={SWATCH_SIZE}
    style={{ backgroundColor: color, borderRadius: SWATCH_RADIUS, opacity }}
  />
);
